export const SETTINGS_URL = {
  FACILITIES_BY_PROVIDER: 'currentprovider/facilities?enabled=true',
  ACCEPT_TOS: 'currentuser/tos',
  GET_PRACTICE: 'currentuser/practices',
  GET_PROVIDER: 'currentuser/providers',
  CURRENT_PROVIDER: 'currentprovider',
  CURRENT_PRACTICE: 'currentpractice',
  USER_SETTINGS: 'currentuser/settings',
  USER_ROLE: 'currentuser/roles',
  USER_PERMISSION: 'currentuser/permissions',
  USER_FEATURE: 'currentuser/features',
  GET_VISIT_STATUS: 'globaldata/visit_statuses_beta',
  GET_DISCHARGE_CODES: 'globaldata/discharge_codes',
  GET_SMART_CPTS: 'globaldata/smartprocedures?place_of_service={POS}&episode_type={ENC_TYPE}',
  GET_CPT:
    'currentprovider/procedures?q={searchString}&place_of_service={pos}&startIndex=0&recordCount={recordCount}',
  FAV_PROCEDURE: 'currentprovider/favprocedures/',
  FAV_DIAGNOSIS: 'currentprovider/favdiagnosis',
  GET_CENSUS_VIEW: 'currentuser/censusview',
  PUT_CENSUS_VIEW: 'currentuser/censusview',
  GET_PICKLIST: 'procedurecodes/procedure_modifiers?pagesize=500&page=0',
  GET_CODETEMPLATES: 'currentpractice/codetemplates',
  GET_MEDICALCHARTTEMPLATES: 'currentpractice/medicalChartTemplates?&enabled=true',
  DEMOGRAPHICS: 'demographics',
}
